export interface DeleteObject {
    key: string;
    type: "folder" | "file";
}

export interface Dimension {
    width: number;
    height: number;
}
export enum ContentSourceType {
    S3Bucket = "S3_BUCKET"
}
export interface ContentSource {
    type: ContentSourceType;
}

export interface S3ContentSource extends ContentSource {
    data: {
        bucketName: string;
        bucketRegion: string;
        identityPoolId?: string;
        AccessKeyId: string;
        SecretAccessKey: string;
        SessionToken: string;
        Expiration: string;
    };
    type: ContentSourceType.S3Bucket;
}

export type ContentSources = S3ContentSource;
export type Contents = S3Content;

export enum MimeType {
    JPEG = "image/jpeg",
    PNG = "image/png",
    GIF = "image/gif",
    MP4 = "video/mp4",
    Webm = "video/webm"
}

export interface S3ContentTypings {
    ownerId?: string;
    ownerDisplayName?: string;
    StorageClass?: string;
}
export interface Content {
    ContentSourceType: ContentSourceType;
    /** rel path i.e aws key */
    relPath: string;
    modifiedAt: number;
    createdAt: number;
    /** Size in bytes of the object */
    size: number;
    url: string;
    identifier: string;
    name: string;
    /** null represents folder */
    mimeType: MimeType | null;
    metadata: {
        thumbnailUrl?: string;
        dimension?: Dimension;
    };
}

export interface S3Object {
    LastModified?: Date;
    Key?: string;
    Size?: number;
}

export interface S3Content extends Content {
    ContentSourceType: ContentSourceType.S3Bucket;
    fullData: S3Object;
}
export interface PaginationMeta {
    total: number;
    perPage: number;
    start: number;
    end: number;
}
export interface ListingResponse {
    data: Content[];
    meta: PaginationMeta;
}
export interface DeleteRequest {
    key: string;
    type: "folder" | "file";
}
export interface DeleteRequestAws {
    Key: string;
}

export interface ListingResponse {
    data: Content[];
    meta: PaginationMeta;
}
